import React from 'react';
import Table from '../../component/table/table'
import { BASE_END_POINT } from '../../urls'
import axios from 'axios'
import Button from '@material-ui/core/Button';
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import './developerRequest.css'
import { message, DatePicker, ConfigProvider } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import allStrings from '../../assets/strings'
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom'
import { ChangeLanguage } from '../../redux/actions/LanguageAction'
import { CSVLink } from "react-csv";
import moment from 'moment'
import locale_ar from 'antd/lib/locale/ar_EG';
import locale_en from 'antd/lib/locale/en_GB';
import 'moment/locale/ar';
import PaginationButtons from '../../component/pagenation/pagenation';
const { RangePicker } = DatePicker;
let headers = [
  { label: "#", key: "id" },
  { label: "اسم الشركة", key: "companyName" },
  { label: "رقم الجوال", key: "phone" },
  { label: "تصنيف المشروع", key: "projectClassification" },
  { label: "المدينة", key: "city" },
  { label: "المنطقة", key: "area" },
  { label: " نوع المشروع", key: "subCategory" },
  { label: "تاريخ الطلب", key: "createdAt" },
];

let csvData = [

];
class developerRequest extends React.Component {

  state = {
    developerRequest: [],
    developerRequest2: [],
    loading: true,
    refresh: false,
    page: 1,
    pages: 1,
    search: null,
    status: null,
    showFilter: false,
    startDate: null,
    endDate: null,
    csvData: [],
    count: 0,
    isReady: false,
    buildCsv: false
  }

  constructor(props) {
    super(props)
    window.scrollTo(0, 0)
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }

  componentDidMount() {
    this.getDeveloperRequests(1, false)
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }

  delete = (id) => {
    console.log("ID   ", id)
    let l = message.loading('Wait..', 2.5)
    axios.delete(`${BASE_END_POINT}developerRequests/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      },
    })
      .then(response => {
        console.log("developerRequest DELETED")
        l.then(() => message.success(allStrings.done, 2.5))
        this.getDeveloperRequests(this.state.page)
      })
      .catch(error => {
        console.log(error.response)
        l.then(() => message.error(allStrings.error, 2.5))
      })
  }
  getDeveloperRequests = (page, refresh) => {
    this.setState({ loading: true })
    let { status, startDate, endDate, search } = this.state
    let url = `${BASE_END_POINT}developerRequests?page=${page}`
    if (refresh !== true) {
      let keysToFilter = { status, startDate, endDate, search }
      Object.keys(keysToFilter).forEach(key => {
        if (keysToFilter[key] !== null) {
          url += `&${key}=${keysToFilter[key]}`;
        }
      });
    }

    axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en',
      },
    })
      .then(response => {
        console.log("developerRequest   ", response.data)
        let data = response.data.data.map((item, index) => {
          return [
            item.id,
            item.companyName.substr(0, 15),
            item.phone,
            item.projectClassification === "READY" ? { type: 'tag', value: allStrings.ready } : { type: 'tag', value: allStrings.offPlanSale },
            item.city ? item.city.cityName : "",
            item.area ? item.area.areaName : "",
            item.subCategory ? item.subCategory.categoryName : "",
            item.createdAt ? this.props.isRTL ? moment(item.createdAt).locale('ar').format('ll') : moment(item.createdAt).locale('en').format('ll') : "",
            "action"
          ]
        })
        this.setState({
          loading: false,
          refresh: false,
          developerRequest: response.data.data,
          developerRequest2: data,
          page: response.data.page,
          count: response.data.totalCount,
          pages: response.data.pageCount,
        })
      })
      .catch(error => {
        console.log("error   ", error.response)
        console.log("error2   ", error)
        this.setState({ loading: false, })
      })
  }
  getDeveloperRequestsWithoutPagenation = (refresh) => {
    let { status, startDate, endDate, search } = this.state
    let url = `${BASE_END_POINT}developerRequests/withoutPagenation/get`
    if (refresh !== true) {
      let keysToFilter = { status, startDate, endDate, search }
      Object.keys(keysToFilter).forEach(key => {
        if (keysToFilter[key] !== null) {
          url += `&${key}=${keysToFilter[key]}`;
        }
      });
    }

    axios.get(url, {
      headers: {
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en',
      }
    })
      .then(response => {

        csvData = response.data.data.map(item => {
          return {
            ...{ id: item.id },
            ...{ companyName: item.companyName.substr(0, 15) },
            ...{ phone: item.phone },
            ...{ projectClassification: item.projectClassification === "READY" ? allStrings.ready : allStrings.offPlanSale },
            ...{ city: item.city ? item.city.cityName : "" },
            ...{ area: item.area ? item.area.areaName : "" },
            ...{ subCategory: item.subCategory ? item.subCategory.categoryName : "" },
            ...{ createdAt: item.createdAt ? this.props.isRTL ? moment(item.createdAt).locale('ar').format('ll') : moment(item.createdAt).locale('en').format('ll') : "" }
          };
        });
        this.setState({ csvData: csvData, isReady: true })
      })
      .catch(error => {
        console.log("error   ", error.response)
        console.log("error2   ", error)
      })
  }
  onChange = (date, dateString) => {
    if (this.props.isRTL) {
      this.setState({
        startDate: moment(dateString[0]).locale('en').format("YYYY-MM-DD"),
        endDate: moment(dateString[1]).locale('en').format("YYYY-MM-DD")
      })
    } else {
      this.setState({ to: moment(dateString).locale('en').format("YYYY/MM/DD") })
      this.setState({
        startDate: moment(dateString[0]).locale('en').format("YYYY-MM-DD"),
        endDate: moment(dateString[1]).locale('en').format("YYYY-MM-DD")
      })
      console.log(moment(dateString[0]).locale('en').format("YYYY-MM-DD"))

    }
    console.log(dateString);
  }

  render() {
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('DEVELOPER-REQUESTS')) return <Redirect to='/Home' />

    return (
      <div className="App">

        <MDBContainer>
          <MDBRow>
            <MDBCol md="12">
              <div className="screenTable">
                <Table
                  settings={
                    <div>
                      <i class="fab fa-searchengin searchIcon" onClick={() => this.setState({ showFilter: !this.state.showFilter })}></i>
                      <span
                        style={{ zIndex: '1', position: 'relative', padding: '4px', color: '#659FF1', fontSize: '25px', borderRadius: '50%', top: '4px', cursor: 'pointer' }}
                        onClick={() => { this.getDeveloperRequests(1, true); this.setState({ buildCsv: false }) }}
                        class="material-icons">
                        replay
                      </span>
                      {!this.state.buildCsv &&
                        <img crossorigin="anonymous" alt="" onClick={() => { this.setState({ buildCsv: true }); this.getDeveloperRequestsWithoutPagenation() }}
                          style={{ padding: '0px', position: 'relative', top: '-6px', marginLeft: '5px', cursor: 'pointer' }}
                          src={require('../../assets/images/buildCsv.png')} width="26"></img>
                      }{!this.state.isReady && this.state.buildCsv &&
                        <img crossorigin="anonymous" alt=""
                          style={{ padding: '0px', position: 'relative', top: '-5px', marginLeft: '-15px' }}
                          src={require('../../assets/images/loading.gif')} width="70"></img>
                      }{this.state.isReady && this.state.buildCsv &&
                        <CSVLink
                          data={this.state.csvData}
                          headers={headers}
                          filename={"developerRequests.csv"}
                          style={{ padding: '10px', position: 'relative', top: '-5px' }}
                        >
                          <img alt="" src={require('../../assets/images/export-csv.png')} width="28"></img>
                        </CSVLink>
                      }
                    </div>
                  }
                  filter={
                    <div>
                      <div className={this.state.showFilter ? 'showClass' : 'hideClass'}>

                        <MDBRow>
                          <MDBCol xl="6" lg="6" md="6" sm="12">
                            <label htmlFor="form605" className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.date}</label>
                            <ConfigProvider locale={this.props.isRTL ? locale_ar : locale_en}>
                              <RangePicker format={"YYYY-MM-DD"} placeholder={[allStrings.startDate, allStrings.endDate]} onChange={this.onChange} />
                            </ConfigProvider>
                          </MDBCol>
                          <MDBCol xl="6" lg="6" md="6" sm="12">
                            <div class="md-form">
                              <label htmlFor="form605" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.Search}</label>
                              <input style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', fontWeight: '300' }} type="text" id="form605" class="form-control"
                                placeholder={allStrings.Search}
                                onChange={(e) => {
                                  this.setState({ search: e.target.value })
                                }}
 placeholder="أدخل البيانات..."                              />
                            </div>
                          </MDBCol>
                        </MDBRow>
                        <Button style={{ background: 'linear-gradient(135deg, #1D9598, #127275)', color: '#fff', width: '100%', margin: '32px auto' }}
                          onClick={() => { this.getDeveloperRequests(1); this.setState({ buildCsv: false }) }}><SearchOutlined /> {allStrings.Search}</Button>

                      </div>
                    </div>
                  }
                  title={allStrings.developerRequests}
                  enableEdit={false}
                  noDelete={false}
                  icon='attach_money'
                  data={this.state.developerRequest}
                  data2={this.state.developerRequest2}
                  tableColumns={["#", allStrings.company, allStrings.phone, allStrings.projectClassification, allStrings.city, allStrings.area, allStrings.subCategory, allStrings.createdAt, allStrings.action]}
                  loading={this.state.loading}
                  deleteItem={(id) => { this.delete(id) }}
                  path='/developerRequestInfo'
                  actionIndex={5}
                  dataCount={this.state.count}
                />
                <PaginationButtons
                  page={this.state.page}
                  pages={this.state.pages}
                  labels={allStrings}
                  onPageChange={(newPage) => {
                    this.getDeveloperRequests(newPage);
                    this.setState({ page: newPage });
                  }}
                />
              </div>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </div>
    )
  }
}

const mapToStateProps = state => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
})

const mapDispatchToProps = {
  ChangeLanguage
}

export default withRouter(
  connect(mapToStateProps, mapDispatchToProps)(developerRequest)
);

